import { atom } from 'recoil';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';

export const coverableDetailsAtom = atom<CoverableDTO | undefined>({
    key: 'coverableDetails',
    default: undefined
});
